export type MessagesActiveTab = 'messages' | 'feedMessages';
export type StoryletActiveTab = 'always' | 'sometimes';

export const ALWAYS = 'always';
export const SOMETIMES = 'sometimes';

export interface ISubtabsState {
  messages: MessagesActiveTab,
  storylet: StoryletActiveTab,
}